

export enum InvoiceStatusType {
  NOT_FINALIZED = "NOT_FINALIZED",
  AWAITING_TAX_SUBMISSION = "AWAITING_TAX_SUBMISSION",
  AWAITING_TAX_PROC_COMPLETION = "AWAITING_TAX_PROC_COMPLETION",
  TAX_PROC_VALIDATION_FAILURE = "TAX_PROC_VALIDATION_FAILURE",
  PENDING = "PENDING",
  FINALIZED = "FINALIZED",
  REJECTED = "REJECTED",
}
